// TODO, create context for options since they're global
export { default } from './EmotionSelectorContainer';